import { mapWorkflowActionToSonarObjectType } from '@sonar-software/sonar-ts-lib';
import { PeriscopeSfWorkflowAction } from '@sonar-software/sonar-ts-types';
import { PeriscopeWorkflowAction } from './PeriscopeWorkflowAction';
import { usePeriscopeActions } from '@hooks';
import React, { useCallback } from 'react';

export interface SalesforceWorkflowActionRowProps {
	action: PeriscopeSfWorkflowAction;
	parentIndex: number;
}

export const WorkflowActionRow: React.FC<SalesforceWorkflowActionRowProps> = ({
	action,
	parentIndex
}) => {
	const { openPeriscope } = usePeriscopeActions();

	const handleActionClick = useCallback(
		(item: PeriscopeSfWorkflowAction) => {
			const { displayName, sonarObjectId } = item;

			openPeriscope({
				id: sonarObjectId,
				name: displayName,
				openedFromIndex: parentIndex,
				type: mapWorkflowActionToSonarObjectType(action.actionType)
			});
		},
		[ action.actionType, openPeriscope, parentIndex ]
	);

	return (
		<PeriscopeWorkflowAction
			action={ action }
			index={ parentIndex }
			onActionClick={ handleActionClick } />
	);
};
